import { render, staticRenderFns } from "./PaymentDetail.vue?vue&type=template&id=ef4e7c42"
import script from "./PaymentDetail.vue?vue&type=script&lang=js"
export * from "./PaymentDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports